const createHash = time => {
  let hash = null;
  try {
    hash = Math.random();
    if (typeof btoa === 'function') {
      return btoa(hash);
    }
  } catch (error) {}
  return hash;
};

export default createHash;
